var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('sequential-entrance',{attrs:{"fromTop":""}},[_c('ScanQRHeader')],1),_c('v-main',[_c('v-container',[_c('ScanQRBody')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }